export interface ExperienceItem {
  company: string
  role: string
  location: string
  period: string
  impact: string
  metric: string
  metricLabel: string
}

export const experience: ExperienceItem[] = [
  {
    company: 'KevinRoot Medical',
    role: 'Lead Product Designer',
    location: 'California, USA (Remote)',
    period: '2024–2026',
    impact:
      'Redesigned the OMS/EHR ERP behind 400+ orthopedic clinics, unifying 13,700+ product customizations and $30M+ in order volume into one system. Cut approval cycles by ~90% with live prototypes and launched GoMFO, a new D2C business unit.',
    metric: '+17%',
    metricLabel: 'YoY revenue growth',
  },
  {
    company: 'GoLaunch',
    role: 'Founder, Product Owner & Consultant',
    location: 'Madrid, Spain',
    period: '2019–2026',
    impact:
      'Led cross-functional teams for early-stage health and ops startups in 4 countries. Launched Narra Health, now serving 6,000+ seafarers across 27 clients, and Clinica.ph, built for up to ₱700M in claims volume.',
    metric: '$4M+',
    metricLabel: 'Raised by clients',
  },
  {
    company: 'Sarisuki',
    role: 'Operations Tech & Platform Product Owner',
    location: 'Manila, Philippines',
    period: '2022–2024',
    impact:
      'Led 16 sprints for a 13-engineer team at a Series A grocery platform. Shipped in-house fulfillment that saved $7.5K a month in tech burn, and finance tools that cut the cash conversion cycle from 45 to ~5 days.',
    metric: '2h → 5m',
    metricLabel: 'Core ops task',
  },
  {
    company: 'Kinhub',
    role: 'Head of Product and Design',
    location: 'London, UK',
    period: '2022–2023',
    impact:
      'Rebuilt the product function from scratch, scaled the team to 7 in 6 months, and shipped a B2C platform, Consultant Portal, Admin Panel, and AI Chatbot, securing 2 client pilots.',
    metric: '4',
    metricLabel: 'Products in 8 months',
  },
]
